import request from '@/utils/request'
import { baseURL } from '@/utils/getawayModule'

/***
 *
 * 获取商品表列表 get
 * @param query 分页参数
 * @return request
 * */
export function getGoodsList(query) {
  return request({
    url: `${baseURL.businessApi}/goodss`,
    method: 'get',
    params: query
  })
}

/**
 * 增加商品表 post
 * @param data 增加的数据
 * @return request
 * */
export function addGoods(data) {
  return request({
    url: `${baseURL.businessApi}/goodss`,
    method: 'post',
    data: data
  })
}

/**
 * 删除商品表  delete
 * @param id 商品表id
 * @return request
 * */
export function deleteGoods(id) {
  return request({
    url: `${baseURL.businessApi}/goodss/${id}`,
    method: 'delete'
  })
}

/**
 * vip商品表  delete
 * @return request
 * */
export function vipGoods() {
  return request({
    url: `${baseURL.businessApi}/goodss/vip`,
    method: 'get'
  })
}

/***
 * 修改商品表 Post
 * @param id 要修改的商品表id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateGoods(id, data) {
  return request({
    url: `${baseURL.businessApi}/goodss/${id}`,
    method: 'post',
    data: data
  })
}


/**
 * 根据id查询商品
 * @param id
 * @returns {AxiosPromise}
 */
export function getGoodsById(id) {
  return request({
    url: `${baseURL.businessApi}/goodss/${id}`,
    method: 'get',
  })
}

/**
 * 查询商品ID名称
 * @returns {AxiosPromise}
 */
export function getGoodsName() {
  return request({
    url: `${baseURL.businessApi}/goodss/getGoodsName`,
    method: 'get',
  })
}

/**
 * 上下架商品
 * */
export function updateGoodsStatus(id, status) {
  return request({
    url: `${baseURL.businessApi}/goodss/status/${id}/${status}`,
    method: 'post'
  })
}
